// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 922 ? "c15bf2b0" : chunkId) + "." + {"815":"e0ec611a612390b9","876":"11869b960ba2c994","922":"f99e3bfc683b8730"}[chunkId] + ".js";
};